export const zIndex = {
    contentFixed: 994
}